export enum FinancialCreditClientTypeEnum {
    CREDIT = 'Crédito',
    DEBIT = 'Débito'
}

export type FinancialCreditClientType = 'CREDIT' | 'DEBIT';
